import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpApi from 'i18next-http-backend';
import LanguageDetector from 'i18next-browser-languagedetector';

// Initialize i18next
i18n
  .use(HttpApi) // Load translations from files
  .use(LanguageDetector) // Detect language from localStorage
  .use(initReactI18next) // Pass to React
  .init({
    fallbackLng: 'fr', // French is default language
    debug: false, // Disable debug in production
    supportedLngs: ['fr', 'en'], // Supported languages
    ns: ['translation', 'serverMessages'],
    defaultNS: 'translation',
    interpolation: {
      escapeValue: false, // React already escapes content
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json', // Path to translations
      // Cache-busting : les locales sont servies avec un cache long (30 j).
      // On versionne l'URL pour forcer le rechargement après chaque déploiement.
      queryStringParams: { v: process.env.REACT_APP_SENTRY_RELEASE || '2' },
    },
    detection: {
      // Check localStorage for saved language preference first
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'], // Save user preference to localStorage
      lookupLocalStorage: 'i18nextLng',
    },
  });

export default i18n;
